import state from "./moduleCommonState.js";
import mutations from "./moduleCommonMutations.js";
import actions from "./moduleCommonActions.js";
import getters from "./moduleCommonGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
